// import Link from 'next/link';
import React, {useEffect, useState} from 'react'
import QuoteList from "./quote-list";
import QuoteDetail from "./quote-detail";
import {searchThemes} from "../theme/services/theme-data-service";
import {searchTags} from "../common/services/tag-data-service";

const QuoteDashboard = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [selectedQuote, setSelectedQuote] = useState(null);
    const [allThemes, setAllThemes] = useState([]);
    const [allTags, setAllTags] = useState([]);

    useEffect(() => {
        getThemesList();
        getTagsList();
    }, [initialStep]);

    const getThemesList = async () => {
        const themesListResult = await searchThemes('')
        setAllThemes(themesListResult);
    }

    const getTagsList = async () => {
        const tagsListResult = await searchTags('');
        setAllTags(tagsListResult);
    }

    return (
        <>

            <div className="page-container dashboard-container">
                <div className="items-center justify-start w-1/3 p-8 mb-28">
                    <div className="flex justify-between mb-6">
                        <div className="text-xl">
                            Quotes
                        </div>

                        <div className="float-right">
                            <a href="/quotes/add-quotes" className="button-medium">
                                <span>Add New Quotes</span>
                            </a>
                        </div>
                    </div>

                    <QuoteList
                        allThemes={allThemes}
                        selectedQuote={selectedQuote}
                        setSelectedQuote={setSelectedQuote}/>
                </div>

                <div className="items-center justify-start w-2/3 pb-16 mr-8 my-8">
                    <QuoteDetail
                        allThemes={allThemes}
                        allTags={allTags}
                        selectedQuote={selectedQuote}
                        setSelectedQuote={setSelectedQuote}/>
                </div>
            </div>

        </>
    )
}

export default QuoteDashboard
